import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-verify-teacher-email',
  templateUrl: './verify-teacher-email.component.html',
  styleUrls: ['./verify-teacher-email.component.scss']
})
export class VerifyTeacherEmailComponent implements OnInit {
  error: string | null = null;
  success = false;
  loading = true;
  project = 'hklsc_pthyxs';
  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.project = this.apiService.project;
    this.route.params.subscribe(params => {
      const { uuid, uuid_hash, email_hash } = params;

      if (!uuid || !uuid_hash || !email_hash) {
        this.error = '驗證參數不完整。';
        this.loading = false;
        return;
      }

      this.apiService.verifyTeacherEmail({
        user_uuid: uuid,
        uuid_hash,
        email_hash
      }).subscribe({
        next: res => {
          this.success = true;
          this.loading = false;
        },
        error: err => {
          this.error = err?.error?.msg || '無法驗證電郵地址。';
          this.loading = false;
        }
      });
    });
  }
}
